
import { Vue } from 'vue-class-component';
import { ElLoading, ElMessage, ElMessageBox } from 'element-plus';
import CreateUserInfoModel from '@/models/userInfos/createUserInfoModel';
import AccountType from '@/constants/AccountType';
import RoleService from '@/services/roleService';
import CurrentUserService from '@/services/currentUserService';
import ErrorCode from '@/constants/ErrorCode';
import * as countryAreaCode from '@/assets/data/countryAreaCode.json';
import UserInfoService from '@/services/userInfoService';
import CommonValidate from '@/services/commonValidate';

export default class UserInfo extends Vue {
private countryAreaCodes = (countryAreaCode as any).default;

 private userList=[];

 private roleList=[];

 private dialogVisible=false;

 private searchValue='';

 private page=1;

 private size=10;

 private total=0;

 private createModel=new CreateUserInfoModel();

 private rules= {
   nickName: [
     {
       required: true, whitespace: true, message: '请输入账号昵称', trigger: 'blur',
     }, { validator: CommonValidate.validateNickName, trigger: 'blur' },
   ],
   userAccount: [
     {
       required: true, whitespace: true, message: '请输入账号名', trigger: 'blur',
     }, { validator: CommonValidate.validateAccount, trigger: 'blur' },
   ],
   phoneNo: [
     {
       required: true, whitespace: true, message: '请输入手机号码', trigger: 'blur',
     }, { validator: CommonValidate.validatePhone, trigger: 'blur' },
   ],
   accessGroup: [
     { required: true, message: '请选择角色', trigger: 'change' },
   ],
 };

 mounted(): void {
   this.loadData();
   this.loadRole();
 }

 loadRole(): void {
   const currentAccountType = CurrentUserService.userInfo.accountType;
   const accountType = currentAccountType === AccountType.PlateAccount || currentAccountType === AccountType.PlateSubAccount ? AccountType.PlateSubAccount : AccountType.CustomerSubAccount;
   RoleService.getAll().then((result) => {
     if (result.code === ErrorCode.Success) {
       this.roleList = result.data.filter((it:any) => it.accountType === accountType);
     }
   }).catch((err) => {
     if (err) {
       console.log(err);
       ElMessage.error(err.msg);
     }
   });
 }

 loadData(): void {
   UserInfoService.getAll(this.page, this.size, this.searchValue).then((result) => {
     if (result.code === ErrorCode.Success) {
       this.userList = result.data.data;
       this.total = result.data.total;
     }
   }).catch((response) => {
     console.log(response);
     ElMessage.error(response.msg);
   });
 }

 pageChange(currentPage:number): void {
   this.page = currentPage;
   this.loadData();
 }

 save():void {
   const form:any = this.$refs.createform;
   form.validate((valid:boolean) => {
     if (valid) {
       const loadingInstance = ElLoading.service({
         lock: true,
         text: 'Loading',
         spinner: 'el-icon-loading',
         background: 'rgba(0, 0, 0, 0.7)',
       });
       UserInfoService.create(this.createModel).then((response) => {
         loadingInstance.close();
         if (response.code === ErrorCode.Success) {
           ElMessage.success(response.msg);
           this.loadData();
           this.dialogVisible = false;
           form.resetFields();
         } else {
           ElMessage.error(response.msg);
         }
       }).catch((response) => {
         loadingInstance.close();
         console.info(response);
         ElMessage.error(response.msg);
       });
     }
   });
 }

 detail(id:string):void {
   this.$router.push({ path: `/userinfo/${id}` });
 }

 resetPass(id:string):void {
   ElMessageBox.confirm('你确定要重置此账号密码', '提示', {
     confirmButtonText: '确定',
     cancelButtonText: '取消',
     type: 'warning',
   }).then(() => {
     UserInfoService.resetPassword(id).then((response) => {
       if (response.code === ErrorCode.Success) {
         ElMessage.success(response.msg);
       } else {
         ElMessage.error(response.msg);
       }
     }).catch(() => {
       ElMessage.error('操作失败');
     });
   });
 }

 updateStatus(id:string, status:number):void {
   UserInfoService.updateStatus(id, status).then((response) => {
     if (response.code === ErrorCode.Success) {
       this.loadData();
       ElMessage.success(response.msg);
     } else {
       ElMessage.error(response.msg);
     }
   }).catch(() => {
     ElMessage.error('操作失败');
   });
 }
}
